import { Query } from '@/app/tracking/api';

export interface QueryInteractionResultsTrackingQueryPayload {
}

export interface QueryInteractionResultsTrackingQueryResult {
  interactionResults: InteractionResult[]
}

export interface InteractionResult {
  id: string
  progress: number
  status: 'incomplete' | 'completed' | 'not-attempted'
}

export const QueryInteractionResultsTrackingQueryName = 'query-interaction-results' as const
export type QueryInteractionResultsTrackingQuery =
      Query<typeof QueryInteractionResultsTrackingQueryName, QueryInteractionResultsTrackingQueryPayload, QueryInteractionResultsTrackingQueryResult>
